import { push } from "connected-react-router";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
  ROUTE_PATH
} from "../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";
import { ValidateString } from "../../../app/utils";
import { ErrorMark } from "../../../components/RegularComponents";
import { usePathApplication } from "../../../redux/hooks/usePathApplication";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { setCurrentAgentMBLRALicenceNumber } from "../../../redux/slice/additionalApplicationsSlice";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import TopNavigationBar from "../../TopNavigationBar";
import styles from "../mra.module.scss";

export const MRALicenceNumber = (props) => {
  const dispatch = useDispatch();
  const { application } = usePathApplication();
  const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
  const isPrincipalBroker =  (ROUTE_PATH.PB_APP.search(application) !== -1);
  // const agentApplication = useSelector(currentAgentApplicationSelector)
  const licencingSubType = agencyApplication ? agencyApplication.licencingSubType : LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
  // const isPrincipalBroker = (licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION)
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType)
  const applicationMode = APPLICATION_MODE_NEW;
  
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  const [showError, setShowError] = useState(false)
  const [errorString, setErrorString] = useState(null)

  // const checkLicenceNumber = () => {
  //   let regex = /^[0-9]{4}-([0-9]{6,7})$/i

  //   return regex.test(licenceNumber)

  // }

  const handleNext = () => {
    setApplicationSaveError(false);

    // MRA - 1017 : removing licence number check for now
    // if (0 && !checkLicenceNumber()) {
    //   setLicenceNumberError("licence number needs to be of the format YYYY-1234567");
    //   return;
    // }

    if (ValidateString(licenceNumber, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR) {
      setShowError(true)
      setErrorString(ERROR_STRING.LICENCE_NUMBER_EMPTY)
      return false
    }

    setShowError(false)
    setErrorString(null)

    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        dispatch(
          push(
            `/${application}${ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONFIRM_COMPLETION_REGULATORY_INFO}`
          )
        );
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });

    return true
  };

  const licenceNumber = useMemo(() => {
    return agencyApplication?.businessLicenceData?.mblraLicenceNumber ?? "";
  }, [agencyApplication]);

  const handleChange = (e) => {
    const { value } = e.target;
    setShowError(false)
    dispatch(setCurrentAgentMBLRALicenceNumber(value));
  };
  // const [licenceNumberError, setLicenceNumberError] = useState(null);
  
  const title = !isPrincipalBroker
    ? "Provide the applicant's mortgage broker licence number under the MRA"
    : "Provide your mortgage broker licence number under the MRA";
  const paragraph1 = !isPrincipalBroker
    ? "If the applicant has an individual licence in Nova Scotia, enter the individual licence number."
    : "If you have an individual licence in Nova Scotia, enter the individual licence number.";
  const paragraph2 = !isPrincipalBroker
    ? "If the applicant is licensed under a brokerage, enter the brokerage licence number."
    : "If you are licensed under a brokerage, enter the brokerage licence number.";

  return (
    <div className="container">
      <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
      {/* Title */}
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{title}</h1>

          <p>{paragraph1}</p>
          <p>{paragraph2}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className={
            "ns-fieldset" + (showError ? " has-error ns-fieldset-message-error" : "")
          }>
          <fieldset className="ns-fieldset">
            <label
              id={"mortgage-broker-licence-number-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"mortgage-broker-licence-number-text"}
            >
              Licence number
            </label>
            {showError && (
              <span
                id={"mortgage-broker-licence-number-text-error"}
                className="ns-error-message field-validation-error"
              >
                {errorString}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (!showError ? " ns-input" : " ns-input--error")
              }
              id={"mortgage-broker-licence-number-text"}
              name={"mortgage-broker-licence-number-text"}
              value={licenceNumber}
              onChange={handleChange}
            />
          </fieldset>
          </div>
        </div>
      </div>

      {/* Yes/No Answer */}
      <div className="row">
        <div
          className={"col-lg-4" + ((applicationSaveError) ? " has-error" : "")}
        >
          <button
            className={`${styles["question_button"]} btn-lg btn-default`}
            onClick={handleNext}
            name={"Save and next"}
          >
            Save and next
          </button>
          {(applicationSaveError) && ErrorMark()}
          {applicationSaveError && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
